import { type GooglePayMerchantInfo } from '../../../../types/StoreState';

export const getMerchantInfo = ({ domain, ...rest }: GooglePayMerchantInfo) => ({
  merchantOrigin: domain,
  ...rest,
});
